import { cn } from '@/lib/utils';

const FullscreenMessage = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center h-screen',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default FullscreenMessage;
